import _get from 'lodash/get'

export const addresses = [
  {
    key: 'permissionManagerAddress',
    label: 'supported-networks.lbl-permission-manager-address',
    help: '',
  },
  {
    key: 'smtDistributorContract',
    label: 'supported-networks.lbl-smt-distributor-address',
    help: '',
  },
  {
    key: 'offerListenerAddress',
    label: 'supported-networks.lbl-dotc-manager-address',
    help: '',
  },
  {
    key: 'actionManagerAddress',
    label: 'supported-networks.lbl-action-manager-address',
    help: '',
  },
  {
    key: 'assetTokenAddress',
    label: 'supported-networks.lbl-asset-token-address',
    help: '',
  },
  {
    key: 'cpkFactoryAddress',
    label: 'supported-networks.lbl-cpk-factory-address',
    help: '',
  },
  {
    key: 'bpoolProxyAddress',
    label: 'supported-networks.lbl-bpool-proxy-address',
    help: '',
  },
]

export class SupportedNetworkRecord {
  constructor (record) {
    this._record = record

    this.chainId = _get(record, 'chainId', '')
    this.name = _get(record, 'name', '')
    this.network = _get(record, 'network', '')
    this.networkId = _get(record, 'networkId', '')
    this.minOwnerBalance = _get(record, 'minOwnerBalance', '')
    this.explorerUrl = _get(record, 'explorerUrl', '')
    this.rpc = _get(record, 'rpc', '')
    this.subgraphUrl = _get(record, 'subgraphUrl', '')
    this.wssRpc = _get(record, 'wssRpc', '')

    this.editable = false

    this.addresses = []
    addresses.forEach(k => {
      const row = {}
      Object.keys(k).forEach(key => {
        row[key] = k[key]
      })
      row.value = record[k.key]
      this.addresses.push(row)
    })
  }
}
